export default {
  title: "Profil",
  buttons: {
    logout: "Chiqish",
  },
  labels: {
    email: "Elektron pochta",
    phone: "Telefon raqami",
  },
  placeholders: {
    notSpecified: "Ko‘rsatilmagan",
  },
  sections: {
    usefulContacts: "Foydali kontaktlar",
  },
  notifications: {
    profileChanges:
      "Ma’lumotlarni o‘zgartirish zarur bo‘lsa, iltimos, qo‘llab-quvvatlash xizmatiga {phone} raqami orqali, {telegram}, {whatsapp} messenjerlarida yoki {email} elektron pochtasi orqali murojaat qiling.",
  },
  tariff_badge: {
    lite_p: "Layt",
    promo_p: "Promo",
    basic: "Asosiy",
    pluspro_p: "Pro+",
    corporate: "Korporativ",
  },
  tariff_hint:
    "Obuna mavjud emas, barcha funksiyalarga kirish uchun tarifni tanlang",
  choose_tariff_button: "Tarifni tanlash",

  contactCard: {
    titles: {
      priorityService: "Imtiyozli xizmat ko‘rsatish",
      distributor: "Distributor",
    },
    hints: {
      upgradeTariff:
        "To‘lovli tarifga ulansangiz, shaxsiy menejer bilan bog‘lanish ma’lumotlari ochiladi",
    },
    upgradeTariff: {
      message:
        "To‘lovli tarifda shaxsiy menejer bilan muammolaringizni tezroq hal qiling.",
      button: "Tarifni sotib olish",
    },
    extNumber: "qo‘sh.",
  },
  managerSchedule: {
    todayWithTime: "Bugun {time} (MSK)",
    todayDayOff: "Bugun - dam olish kuni",
    weekdays: {
      monday: "Dushanba",
      tuesday: "Seshanba",
      wednesday: "Chorshanba",
      thursday: "Payshanba",
      friday: "Juma",
      saturday: "Shanba",
      sunday: "Yakshanba",
    },
  },
};
